import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { costingPageDef } from '@/components/scm/scm-page-defs';

export default function ScmCostingPage() {
  return <ScmPageRenderer pageDef={costingPageDef} />;
}
